import React from 'react';
const categories = [{
  label: 'Stock purchases',
  amount: '412,000',
  share: 58
}, {
  label: 'Transport & fuel',
  amount: '186,500',
  share: 26
}, {
  label: 'Rent & utilities',
  amount: '112,200',
  share: 16
}];
export function ExpensesMock() {
  return <div className="w-full max-w-[330px] rounded-[12px] bg-white p-5 shadow-[0_18px_40px_-24px_rgba(11,11,11,0.28)]" data-id="element-772" data-mp="1x92x7cif2r01">
      <div className="flex items-baseline justify-between" data-id="element-773" data-mp="1oailivb9xhlb">
        <p className="text-[14px] font-semibold text-ink" data-id="element-774" data-mp="1o8xsxb8is8q3">Expenses this month</p>
      </div>
      <p className="mt-2 text-[24px] font-semibold tracking-[-0.02em] text-ink" data-id="element-775" data-mp="1sdnmuujmbd8d">710,700</p>

      <ul className="mt-5 space-y-4" data-id="element-776" data-mp="1edmjn8fvrtpq">
        {categories.map(c => <li key={c.label} data-id="element-777" data-mp="1jamfkqj0ng34">
            <div className="flex items-center justify-between text-[13px]" data-id="element-778" data-mp="1jbxv1nltqca2">
              <span className="text-ink-muted" data-id="element-779" data-mp="38q2ktuttkhnq">{c.label}</span>
              <span className="font-medium text-ink" data-id="element-780" data-mp="3dpf8uiwffurw">{c.amount}</span>
            </div>
            <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-canvas-line" data-id="element-781" data-mp="3dn2v6hxpc6kn">
              <div className="h-full rounded-full bg-brand" style={{
            width: `${c.share}%`
          }} data-id="element-782" data-mp="l4gityy93hhc" />
            </div>
          </li>)}
      </ul>
    </div>;
}